import React from 'react';
import T from 'prop-types';
import {
  Checkbox,
  FormControlLabel,
  Input,
  MenuItem,
  Select
} from '@material-ui/core';
import SelectFieldWrapper from './style';
import {Body2} from '../typography';
import {FILTER_ORDER_SOURCES} from '../../helpers/constants/orders_v2';

const SelectFiltersOrderV2 = ({
  value,
  onChange,
  menuFulfilmentTypes,
  menuItemsAll,
  menuItemsSources,
  menuItemsPaymentMethod,
  input,
  className,
  optionLabelName,
  emptyLabel,
  ...props
}) => {
  return (
    <SelectFieldWrapper>
      <Select
        className={className}
        value={value}
        onChange={onChange}
        input={input || <Input />}
        renderValue={(selected) => selected.join(', ')}
        {...props}
      >
        {!menuFulfilmentTypes.length +
          !menuItemsSources.length +
          !menuItemsAll.length +
          !menuItemsPaymentMethod.length && (
          <MenuItem disabled>{emptyLabel || 'No locations here!'} </MenuItem>
        )}
        <Body2 className='SelectItemCategory'>All</Body2>
        {menuItemsAll.map((item) => (
          <MenuItem
            key={item._id || item.id || item}
            value={item._id || item.id || item}
          >
            <FormControlLabel
              className='Say2EatCheckbox Say2EatCheckboxSoldOut'
              control={
                <Checkbox
                  name='Invisible'
                  labelStyle={{color: '#172751'}}
                  iconStyle={{fill: '#FF2D38'}}
                  inputStyle={{color: '#FF2D38'}}
                  style={{color: '#FF2D38'}}
                  checked={
                    value.indexOf(item[optionLabelName]) > -1 ||
                    value.indexOf(item) > -1 ||
                    value.indexOf('All') > -1
                  }
                />
              }
            />

            {item[optionLabelName] || item}
          </MenuItem>
        ))}
        <Body2 className='SelectItemCategory'>Order source</Body2>
        {menuItemsSources.map((item) => (
          <MenuItem
            key={item._id || item.id || item}
            value={item._id || item.id || item}
          >
            <FormControlLabel
              className='Say2EatCheckbox Say2EatCheckboxSoldOut'
              control={
                <Checkbox
                  name='Invisible'
                  labelStyle={{color: '#172751'}}
                  iconStyle={{fill: '#FF2D38'}}
                  inputStyle={{color: '#FF2D38'}}
                  style={{color: '#FF2D38'}}
                  checked={
                    value.indexOf(item[optionLabelName]) > -1 ||
                    value.indexOf(item) > -1 ||
                    value.indexOf('All') > -1
                  }
                />
              }
            />
            {FILTER_ORDER_SOURCES[item]}
          </MenuItem>
        ))}
        <Body2 className='SelectItemCategory'>Fulfilment</Body2>
        {menuFulfilmentTypes.map((item) => (
          <MenuItem
            key={item._id || item.id || item}
            value={item._id || item.id || item}
          >
            <FormControlLabel
              className='Say2EatCheckbox Say2EatCheckboxSoldOut'
              control={
                <Checkbox
                  name='Invisible'
                  labelStyle={{color: '#172751'}}
                  iconStyle={{fill: '#FF2D38'}}
                  inputStyle={{color: '#FF2D38'}}
                  style={{color: '#FF2D38'}}
                  checked={
                    value.indexOf(item[optionLabelName]) > -1 ||
                    value.indexOf(item) > -1 ||
                    value.indexOf('All') > -1
                  }
                />
              }
            />
            {item[optionLabelName] || item}
          </MenuItem>
        ))}
        <Body2 className='SelectItemCategory'>Payment method</Body2>
        {menuItemsPaymentMethod.map((item) => (
          <MenuItem
            key={item._id || item.id || `${item}-payment`}
            value={item._id || item.id || item}
          >
            <FormControlLabel
              className='Say2EatCheckbox Say2EatCheckboxSoldOut'
              control={
                <Checkbox
                  name='Invisible'
                  labelStyle={{color: '#172751'}}
                  iconStyle={{fill: '#FF2D38'}}
                  inputStyle={{color: '#FF2D38'}}
                  style={{color: '#FF2D38'}}
                  checked={
                    value.indexOf(item[optionLabelName]) > -1 ||
                    value.indexOf(item) > -1 ||
                    value.indexOf('All') > -1
                  }
                />
              }
            />
            {item[optionLabelName] || item}
          </MenuItem>
        ))}
      </Select>
    </SelectFieldWrapper>
  );
};

SelectFiltersOrderV2.propTypes = {
  value: T.array,
  name: T.string,
  onChange: T.func.isRequired,
  menuFulfilmentTypes: T.array.isRequired,
  menuItemsSources: T.array.isRequired,
  menuItemsPaymentMethod: T.array.isRequired,
  menuItemsAll: T.array.isRequired,
  className: T.string,
  optionLabelName: T.string,
  input: T.oneOfType([T.elementType, T.element]),
  emptyLabel: T.string
};

SelectFiltersOrderV2.defaultProps = {
  value: [],
  name: '',
  className: '',
  input: null,
  optionLabelName: '',
  emptyLabel: ''
};

export default SelectFiltersOrderV2;
